export default "__VITE_ASSET__Brd5ZARd__"